// services/cierreAgenteService.ts
import { api } from "./api";
import { CierreAgenteResponse } from "../types/cierreAgente";

export const CierreAgenteService = {
    crearRelacion: (data: { idCierreAgente: number; idDepositoBanco: number; activo: boolean }) => {
        if (!Number.isInteger(data.idCierreAgente) || data.idCierreAgente < 0 || !Number.isInteger(data.idDepositoBanco) || data.idDepositoBanco < 0) {
            throw new Error("ID y saldo deben ser números positivos");
        }

        return api.post('cierresAgente/boleta/', data)
    },

    crearCierre: (data: CierreAgenteResponse) =>{
        return api.post(`cierresAgente`, data);       
    },

    crearCierre2: (data: CierreAgenteResponse) =>{
        return api.post(`cierresAgente/anterior`, data);       
    },

    getCierre: (id: number, fecha: string) => {
        if (!Number.isInteger(id) || id < 0) {
        throw new Error("ID debe ser un número positivo");
        }
        return api.get(`cierresAgente/${id}/agenteFecha`, {params: {fecha: fecha}});            
    },

   getCierresRango: (fechaInicio: string, fechaFin: string) => {
        return api.get('cierresAgente/resumen', {
            params: {
                fechaInicio: fechaInicio,
                fechaFin: fechaFin
            }
        });
    },

    getCierreAgenteIdFecha: (idAgente: number, fecha: string) => {
        if (!Number.isInteger(idAgente) || idAgente < 0) {
        throw new Error("ID debe ser un número positivo");
        }

        return api.get(`cierresAgente/${idAgente}/${fecha}`);
    },

    getCierresResumenOperador: (id: number) => {
        if (!Number.isInteger(id) || id < 0) {
        throw new Error("ID debe ser un número positivo");
        }
        return api.get(`cierresAgente/operador/${id}`);           
    },

    getCierres: (id: number) => {
        if (!Number.isInteger(id) || id < 0) {
        throw new Error("ID debe ser un número positivo");
        }
        return api.get(`cierresAgente/${id}/unDia`);           
    },

    getCierresFecha: (id: number, fecha: string) => {
        if (!Number.isInteger(id) || id < 0) {
        throw new Error("ID debe ser un número positivo");
        }
        return api.get(`cierresAgente/${id}/fecha`, {params: {fecha: fecha}});           
    },

    getResumenDasboard: () => {
        return api.get('cierresAgente/dashboard/cierres');
    },

    getSaldoSistema: (id: number) => {
        if (!Number.isInteger(id) || id < 0) {
        throw new Error("ID debe ser un número positivo");
        }
        return api.get(`saldosSistema/${id}/individual`);
    },

    getPermiso: (id: number) => {
        if (!Number.isInteger(id) || id < 0) {
        throw new Error("ID debe ser un número positivo");
        }
        return api.get(`saldosSistema/${id}/permiso-edicion`);
    },

    getSaldoAgente: (id: number) => {
        if (!Number.isInteger(id) || id < 0) {
        throw new Error("ID debe ser un número positivo");
        }
        return api.get(`saldosSistema/agente/${id}`);       
    },
    
    crear: (data: { saldo: number; idAgente: number }) => {
        if (!Number.isInteger(data.idAgente) || data.idAgente < 0 || data.saldo < 0) {
            throw new Error("ID y saldo deben ser números positivos");
        }

        return api.post('/saldosSistema', data);
    },

    actualizar: (idSaldo: number, data: { saldo: number}) => {
        if (!Number.isInteger(idSaldo) || idSaldo < 0 || data.saldo < 0){
            throw new Error("ID y saldo deben ser números positivos");
        }
        
        return api.put(`/saldosSistema/${idSaldo}/actualizar`, data)
    },

    actualizarObservacion: (idCierre: number, data: { observacion: string}) => {
        return api.put(`/cierresAgente/observacion/${idCierre}`, data)
    },

    getObservacion: (idCierre: number) => {
        return api.get(`/cierresAgente/observacion/${idCierre}`)
    },

    // Activar edición
    activar: (id: number) => {
        return api.put(`/saldosSistema/${id}/activar`);
    },
}
